var _path, _path2, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var Svg13 = function Svg13(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7742 21H7.59417C5.72945 20.85 2 19.38 2 14.7C2 11.55 5.0625 9.3 7.25 9.3C7.25 7.95 9 3 14.25 3C17.75 3 19.5 5.25 20.5302 6.6C21.4335 6.15 23.875 6.15 25.1875 6.6C26.5 7.05 30 9.3 30 13.8C30 18.3 26.0625 21 22.7742 21Z",
    fill: "url(#paint0_linear_692_423030)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7764 23.1023C16.9708 23.1565 18.2057 26.4613 17.9168 27.5395C17.7751 28.0544 17.4123 28.4862 16.9077 28.7407C16.4031 28.9951 15.7976 29.0516 15.2234 28.8978C14.6493 28.744 14.1532 28.3923 13.8434 27.9196C13.5336 27.4469 13.4354 26.8915 13.5701 26.3749C13.859 25.2966 16.5819 23.0481 16.7764 23.1023Z",
    fill: "#42A0F0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_692_423030",
    x1: 6.91448,
    y1: 4.5068,
    x2: 24.7045,
    y2: 21.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDCFE1"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg13, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/13.269b2ec4.svg";
export { ForwardRef as ReactComponent };